import styles from './NoPermissions.module.scss';

interface NoPermissionsProps {
  salesPersonEmail: string;
}

const NoPermissions = ({ salesPersonEmail }: NoPermissionsProps): React.ReactElement => {
  return (
    <div className={styles.mainWrapper}>
      <div className={styles.title}>No Access</div>
      <div className={styles.description}>
        User has no permissions or active subscription. Contact your account representative at{' '}
        <a href={`mailto:${salesPersonEmail}`}>{salesPersonEmail}</a>
      </div>
    </div>
  );
};

export default NoPermissions;
